import _ from "lodash";
import {Indicator, Toast} from "mint-ui";
import router from "../router/";
import jingjiangErrorCode from "./jingjiangErrorCode";

export default function (axios) {
  axios.interceptors.request.use(
    config => {
      var bApp = window.navigator.userAgent.indexOf("Html5Plus") > 0;

      if (config.url.indexOf("http") != 0) {
        // 此处兼容一下手机点餐
        let ssv = ''
        if (config.vv) {
          ssv = config.vv;
        }
        if (ssv == 6) {
          var gatewayJson = localStorage.getItem("dcgateway");
          //axios封装get请求，data为假时， Content-Type会被清理掉

          let cont = {
            appKey: "00000",
            v: "2.0",
            format: "json"
          };

          //axios封装get请求，data为假时， Content-Type会被清理掉
          if (config.method == 'get') {
            config.data = {unused: 0}
            //console.log("gateway:", gateway)
            config.params = {
              ...cont,
              ...config.params
            };
          } else {
            config.data = Object.assign(config.data, cont);
          }

          if (gatewayJson != null) {
            var gateway = JSON.parse(gatewayJson);
            config.url = `http://${gateway.ip}:${gateway.port}${config.url}`;

            //console.log("gateway:", gateway)
            let userInfo = gateway.userInfo || {}

            //console.log("gateway:", gateway)
            config.headers["Content-Type"] = "application/json;charset=UTF-8";
            config.headers["rop-hotelCode"] = userInfo.hotelCode || "";
            config.headers["rop-hotelGroupCode"] = userInfo.hotelGroupCode || "";
            config.headers["rop-appCode"] = "M_POS";
            config.headers["rop-workstation"] = userInfo.workStationCode || "";
            config.headers["rop-userCode"] = userInfo.userCode || "";
            config.headers["rop-bizDate"] = userInfo.bizDate || "";
            config.headers["rop-shift"] = userInfo.shift || -1
          } else {
            config.url = (localStorage.getItem("con_web_url") || '') + config.url;
          }

          config.dpost = true;

          console.log("vv 6 ajax request config:", config);

        } else { // 普通的mihotel请求处理

          //console.log(config)
          if (localStorage.JWT_TOKEN) {
            config.headers["Authorization"] = localStorage.JWT_TOKEN;
            //加上多语言的判断
          }

          config.headers["language"] = localStorage.language || "zh_CN";
          if (config.timeout == 0) {
            config.timeout = 120000;
          }

          if(window.$isLD){
            if(window.$isLDTest){
              config.url = 'https://test.ihotel.cn' + config.url; // 绿云钉测试服务器地址地址写死
            } else {
              // config.url = 'https://mobile.ihotel.cn' + config.url; // 绿云钉正式地址写死
              config.url = 'https://app127730.eapps.dingtalkcloud.com' + config.url
            }
          }

          if (bApp) {
            // 锦江本地接口
            if (localStorage.getItem('isJingJiang') == 'yes' && config.data && config.data.isJingJiangLocal) {
              let objStr = localStorage.getItem('JingJiangSetting') || "{}"
              let obj = JSON.parse(objStr)
              // config.url = 'https://shengju.imwork.net:19630' + config.url
              if (!obj.jingjiangUrl) {
                Toast({
                  message: "请先配置锦江接口地址",
                  position: "bottom",
                  duration: 3000
                });
              }
              config.url = obj.jingjiangUrl + config.url
              // alert('传给锦江的地址：' + config.url + '/n/n 参数：' + JSON.stringify(config.data, null, 4))
            } else {
              config.url = localStorage.getItem("con_web_url") + config.url;
            }
          }
        }
      }
      if ((config.method == "post" || config.dpost == true) && config.nopost == null) {
        Indicator.open();
      }
      return config;
    },
    error => {
      // Do something with request error
      return Promise.reject(error);
    }
  );
  // Add a response interceptor
  axios.interceptors.response.use(
    function (response) {
      console.log('response: ' + JSON.stringify(response.config))

      if (response.config && response.config.data) {
        let requestInfo = JSON.parse(response.config.data)
        if (requestInfo.isJingJiangLocal) {
          // alert('锦江接口返回结果' + JSON.stringify(response, null, 4))
          console.log('jingjiangErrorCode: ', jingjiangErrorCode);
          let jjData = _.cloneDeep(response.data || {}) // response.data || {}
          response.data.result = jjData.Code
          // 锦江接口返回200或者0都是可能是成功
          if (response.data.result == 200) {
            response.data.result = 0
          }
          response.data.retVal = jjData
          // 没有报错信息时我们这边去匹配
          if (jjData.Message) {
            response.data.msg = jjData.Message
          } else {
            let tempUrl = response.config.url
            let Code = jjData.Code
            let tempMsg = ''
            if (tempUrl.indexOf('CardService/RequestForWrite') > -1) {
              if (requestInfo.CardType == 'IDCard') {
                tempMsg = jingjiangErrorCode.idCard[Code] || ''
              } else {
                tempMsg = jingjiangErrorCode.doorCard[Code] || ''
              }
            } else if (tempUrl.indexOf('CardService/Authorize') > -1) {
              tempMsg = jingjiangErrorCode.auth[Code] || ''
            } else {
              tempMsg = '请求出错了'
            }
            response.data.msg = tempMsg
          }
        }
      }

      // Do something with response data
      //console.log(response)
      if (
        (response.config.method == "post" || response.config.dpost == true) &&
        response.config.nopost == null
      ) {
        Indicator.close();
      }

      if (response.data.result == 50001 && !(response.config && response.config.url && response.config.url.indexOf('/sysOptions/findUserAuth') > -1)) {
        if (window.navigator.userAgent.indexOf("Html5Plus") > 0) {
          console.log("loginout");
          var A = plus.webview.getLaunchWebview();
          A.evalJS("loginOut(false)");
          return;
        }
        router.replace({
          path: "login",
          query: {redirect: router.currentRoute.fullPath}
        });
      }
      return response;
    },
    function (error) {
      if (error.config && error.config.data) {
        console.log('error信息：' + JSON.stringify(error))

        try {
          let temp = JSON.parse(error.config.data)
          if (temp.noErrorToast) {

          } else {
            Toast({
              message: "Network Error",
              position: "bottom",
              duration: 3000
            });
          }
        } catch (e) {
          Toast({
            message: "Network Error",
            position: "bottom",
            duration: 3000
          });
        }
      } else if (error.config && error.config.noErrorToast) {

      } else {
        Toast({
          message: "Network Error",
          position: "bottom",
          duration: 3000
        });
      }
      Indicator.close();
      return Promise.reject(error);
    }
  );
}



// WEBPACK FOOTER //
// ./src/conf/axios.js